import React from "react";
import styles from './index.module.css';
import {Helmet} from 'react-helmet';
import Link from 'gatsby-link';
import favicon from './Mkat.tech_logo3_32.png';


export default class Layout extends React.Component {

  constructor(props) {
    super(props);
    this.state = { navOpen: false };

    this.onClick = this.onClick.bind(this);
    this.closeNav = this.closeNav.bind(this);
  }

  componentDidMount() {
    window.addEventListener('scroll', this.closeNav);
  }

  onClick(event) {
    this.setState({ navOpen: !this.state.navOpen });
  }

  closeNav(event) {
    this.setState({ navOpen: false });
  }

  render() {
    return (
      <div>
        <Helmet
          title='Quo Vadis Journeys'
          meta={[
            {name: 'description', content: "Explore God's world through Catholic pilgrimages"}
          ]}
        >
          <html lang='en' />
          <link rel="shortcut icon" type="image/png" href={favicon} />
        </Helmet>
        <nav className={styles.nav} >
          <div className={styles.navHeader}>
            <h1><Link to='/' className={styles.headerHome} onClick={this.closeNav} >
                Quo Vadis Journeys
            </Link></h1>
            <div className={styles.spacer} />
            { this.state.navOpen
              ? <button className={styles.crossButton} aria-label='Close nav' onClick={this.onClick}>&#735;</button>
              : <button className={styles.button} aria-label='Expand nav' onClick={this.onClick}>
                  <span className={styles.iconBar}></span>
                  <span className={styles.iconBar}></span>
                  <span className={styles.iconBar}></span>
                </button>
              // : <button className={styles.button} onClick={this.onClick}>&#9776;</button>
            }
          </div>
          <ul className={this.state.navOpen
              ? styles.navlist
              : styles.navlist + ' ' + styles.hiddenNavlist
            }>
            <li><Link to='/about' className={styles.headerHome} onClick={this.closeNav} >
                About
            </Link></li>
            <li><Link to='/pilgrimages' className={styles.headerHome} onClick={this.closeNav} >
                Pilgrimages
            </Link></li>
          </ul>
        </nav>
        <div className={this.state.navOpen
            ? styles.fullscreen + ' ' + styles.darkenedBackground
            : styles.fullscreen
          } onClick={this.closeNav}/>
        {this.props.children()}
        <footer>
          <div>
            <h2>Contact</h2>
            <p><a href='tel:469-389-2078'>(469) 389-2078</a></p>
            <p><a href='mailto:quovadisjourneys@gmail.com'>quovadisjourneys@gmail.com</a></p>
          </div>
          <div>
            <h2><Link to='/'>Quo Vadis Journeys</Link></h2>
            <ul>
              <li><Link to='/about'>About</Link></li>
              <li><Link to='/pilgrimages'>Pilgrimages</Link>
                <ul>
                  {this.props.data.journeys.edges.map(edge =>
                    <li><Link to={edge.node.fields.slug}>
                      {edge.node.frontmatter.title}
                    </Link></li>
                  )}
                </ul>
              </li>
            </ul>
          </div>
          <div className={styles.spacer} />
          <p className={styles.mkatLink} >Powered by <a href='https://mkat.tech'>Mkat.tech</a></p>
        </footer>
      </div>
    );
  }
}
          // <ul className={this.state.navOpen ? styles.navlist : styles.hiddenNavlist} >

export const query = graphql`
  query LayoutQuery {
    journeys: allMarkdownRemark(
      filter: { fields: { slug: {regex: "/journeys/"}}}
    ) {
      edges {
        node {
          fields {
            slug
          }
          frontmatter {
            title
          }
        }
      }
    }
  }
`


// WEBPACK FOOTER //
// ./src/layouts/index.js